import {GuideObj, ObjDB} from "../../../../../types/apiTypes";
import React, {useEffect} from "react";
import {useFormStatus} from "../../../../../utils/hooks/useFormStatus";
import {useFormik} from "formik";
import {GuideFormFields} from "../../../../../types/formFieldTypes";
import {getAntField} from "../../../../../utils/form";
import {useMutation} from "react-query";
import {api} from "../../../../../api/api";
import {invalidateQueries} from "../../../../../utils/rest";
import {queryKeysGuide} from "../../../../../static/data/queryKeys";
import EditPlaceholder from "../../../../../components/common/EditPlaceholder/EditPlaceholder";
import {Form} from "antd";
import FormStatus from "../../../../../components/form/FormStatus/FormStatus";
import {clearGuideErrors, guideValidate, initialGuideFields} from "../../formData/GuideFormData";
import GuideFormInputs from "../GuideFormInputs/GuideFormInputs";

type GuideEditFormProps = {
    editItem: ObjDB<GuideObj> | null
    setOpenedForm: React.Dispatch<React.SetStateAction<boolean>>
    setEditItem: React.Dispatch<React.SetStateAction<ObjDB<GuideObj> | null>>
}

const GuideEditForm: React.FC<React.PropsWithChildren<GuideEditFormProps>> = React.memo((props) => {
    const {
        editItem, setOpenedForm, setEditItem
    } = props

    const formStatus = useFormStatus()

    const {
        errors, values, touched,
        handleChange,
        submitForm, setValues, setErrors,
    } = useFormik<GuideFormFields>({
        initialValues: editItem as GuideFormFields,
        onSubmit: (values: GuideFormFields) => {
            mutate(values)
        },
        validate: guideValidate
    })

    const antField = getAntField<GuideFormFields>(values, errors, touched)

    const {
        mutate
    } = useMutation(
        async (values: GuideFormFields) => {
            if (editItem) return await api.guide.edit(values, editItem)
        },
        {
            mutationKey: 'guide-edit',
            onSuccess() {
                invalidateQueries(queryKeysGuide[0])
                formStatus.setMessage('Данные успешно изменены')
                formStatus.setStatus('success')
                setTimeout(clearEditItem, 1000)
            },
            onError(err: Error) {
                console.error('ERROR', err)
                formStatus.setMessage(`Ошибка: ${err.message}`)
                formStatus.setStatus('error')
                setTimeout(clearEditItem, 5000)
            },
            onMutate() {
                formStatus.setMessage('Отправка данных')
                formStatus.setStatus('fetching')
            }
        }
    )

    const clearForm = () => {
        setValues(initialGuideFields)
        setErrors(clearGuideErrors)
    }

    const clearEditItem = () => {
        clearForm()
        setOpenedForm(false)
        setTimeout(() => {
            setEditItem(null)
            formStatus.reset()
        }, 300)
    }

    const resetChanges = () => {
        if (editItem) {
            const { id, ...values } = editItem
            setValues(values)
            setErrors(clearGuideErrors)
        }
    }

    useEffect(() => {
        if (editItem) return resetChanges()
        clearForm()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editItem])


    if (!editItem) return <EditPlaceholder />

    return (
        <Form fields={[
            antField('name'),
            antField('path'),
            antField('text'),
        ]}>
            {
                editItem &&
                <p className="uif-ant-form-title">
                    ID редактируемого объекта: <span>{editItem.id}</span>
                </p>
            }
            <GuideFormInputs
                handleChange={handleChange}
                resetChanges={resetChanges}
                submitForm={submitForm}
                values={values}
            />
            <FormStatus formStatus={formStatus} />
        </Form>
    )
})

export default GuideEditForm